import { render } from "./TableExpress.vue?vue&type=template&id=1fc3d89d"
import script from "./TableExpress.vue?vue&type=script&lang=js"
export * from "./TableExpress.vue?vue&type=script&lang=js"

import "./TableExpress.vue?vue&type=style&index=0&id=1fc3d89d&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__